<template>
  <div>
    <mx-element :title="config.Title" theme="ListTitle" type="Title" v-if="!config.HideTitle">
      <div class="flex-row start middle">
        <mx-element v-if="config.Add" type="Button" theme="Add" :title="config.Add.Title || '新增'" @click="OnAddClick" :disabled="GetDisabled('add')"></mx-element>
        <mx-element v-if="config.Import" type="Button" theme="Import" :title="config.Import.Title || '导入'" @click="OnImportClick" :disabled="GetDisabled('add')"></mx-element>
        <mx-element v-if="config.Export" type="Button" theme="Export" :title="config.Export.Title || '导出'" @click="OnExportClick" :disabled="GetDisabled('query')"></mx-element>
        <mx-element v-if="config.Adds" type="Button" theme="Add" :title="config.Adds.Title || '批量新增'" @click="OnAddsClick" :disabled="GetDisabled('add')"></mx-element>
        <template v-if="TypeActions">
          <mx-element v-for="(action, index) of TypeActions" :key="index" type="Button" :theme="action.Theme || ''" :title="action.Title" @click="OnTypeActionClick(action)" :disabled="GetDisabled(action.Name)"></mx-element>
        </template>
      </div>
    </mx-element>
    <div class="flex-row st start">
      <div v-if="TreeField" style="width: 350px">
        <mx-element :config="TreeField" type="Tree" @change="OnTreeChange" style="overflow-y: auto"></mx-element>
      </div>
      <div v-if="TreeField" style="width: 5px; background-color: #f7f7f7; display: block"></div>
      <div style="flex: 1" v-loading="Posting">
        <mx-form
          v-if="ConditionConfig.Columns.length > 0 && !config.DisabledCondition"
          style="flex: 1; margin: 10px; border-bottom: 1px solid #f7f7f7"
          class=""
          type="Condition"
          :value="Condition"
          :columns="ConditionConfig.Columns"
          ref="condition"
          @change="OnConditionChange"
          :key="Key"
        >
          <template slot="button">
            <mx-element style="margin-left: 10px" type="Button" @click="handleReset" title="搜索" />
            <template v-if="config.HideTitle">
              <mx-element v-if="config.Add" type="Button" theme="Add" :title="config.Add.Title || '新增'" @click="OnAddClick" :disabled="GetDisabled('add')"></mx-element>
              <mx-element v-if="config.Import" type="Button" theme="Import" :title="config.Import.Title || '导入'" @click="OnImportClick" :disabled="GetDisabled('add')"></mx-element>
              <mx-element v-if="config.Export" type="Button" theme="Export" :title="config.Export.Title || '导出'" @click="OnExportClick" :disabled="GetDisabled('query')"></mx-element>
              <mx-element v-if="config.Adds" type="Button" theme="Add" :title="config.Adds.Title || '批量新增'" @click="OnAddsClick" :disabled="GetDisabled('add')"></mx-element>
              <template v-if="TypeActions">
                <mx-element v-for="(action, index) of TypeActions" :key="index" type="Button" :theme="action.Theme || ''" :title="action.Title" @click="OnTypeActionClick(action)" :disabled="GetDisabled(action.Name)"></mx-element> </template
            ></template>
          </template>
        </mx-form>
        <div v-else-if="config.HideTitle" class="flex-row list-half" style="margin: 10px">
          <mx-element v-if="config.Add" type="Button" theme="Add" :title="config.Add.Title || '新增'" @click="OnAddClick" :disabled="GetDisabled('add')"></mx-element>
          <mx-element v-if="config.Import" type="Button" theme="Import" :title="config.Import.Title || '导入'" @click="OnImportClick" :disabled="GetDisabled('add')"></mx-element>
          <mx-element v-if="config.Export" type="Button" theme="Export" :title="config.Export.Title || '导出'" @click="OnExportClick" :disabled="GetDisabled('query')"></mx-element>
          <mx-element v-if="config.Adds" type="Button" theme="Add" :title="config.Adds.Title || '批量新增'" @click="OnAddsClick" :disabled="GetDisabled('add')"></mx-element>
          <template v-if="TypeActions">
            <mx-element v-for="(action, index) of TypeActions" :key="index" type="Button" :theme="action.Theme || ''" :title="action.Title" @click="OnTypeActionClick(action)" :disabled="GetDisabled(action.Name)"></mx-element>
          </template>
        </div>
        <div class="flex-row start wrap top list-half" style="margin: 10px" v-if="config.Tabs && config.Tabs.length > 0">
          <div :class="!currentTab ? 'activeditem' : 'tabitem'" @click="OnSelectTab(null)">全部</div>
          <div v-for="tab in config.Tabs" :key="tab.Title" :class="currentTab === tab ? 'activeditem' : 'tabitem'" @click="OnSelectTab(tab)">
            {{ tab.Title }} {{ TabDatas[tab.Title] ? `(${TabDatas[tab.Title]})` : '' }} <span><i class="el-icon-close" v-if="currentTab === tab"></i></span>
          </div>
        </div>
        <mx-column-data style="margin-top: 4px" :config="config" :dataconfig="DataConfig" tip="数据分页列表" ref="loader" :params="Condition" :is-page="true" @change="OnDataChange">
          <template slot-scope="scope">
            <div v-if="scope.data" class="flex-row stretch wrap start" :key="scope.timespan" style="padding: 0 10px">
              <template v-for="(item, index) in scope.data">
                <slot :index="index" :data="item"></slot>
              </template>
            </div>
            <mx-element type="Empty" v-if="scope.data.length === 0"></mx-element>
            <div v-if="MultActions && scope.data.length > 0" style="text-align: left; padding: 10px">
              <mx-element v-for="(action, index) of MultActions" :key="index" type="Button" :theme="action.Theme || ''" :title="action.Title" :disabled="GetMultDisabled(action, scope.data)" @click="OnDoMultActions(action, scope.data)"></mx-element>
            </div>

            <mx-element
              v-if="scope.pageSize && scope.data.length > 0"
              class="flex:1"
              style="margin-top: 10px; font-size: 16px"
              type="Pager"
              :value="scope.page"
              :config="{
                MaxSize: scope.total,
                PageSize: scope.pageSize
              }"
              @change="handlePager"
              :key="scope.page"
            ></mx-element>
          </template>
          <mx-element type="Loading" slot="loading"></mx-element>
        </mx-column-data>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
    index: Number,
    dataconfig: Object,
    panel: String,
    parent: Object,
    selected: Object,
    query: Object
  },
  data() {
    return {
      Condition: {},
      Key: new Date().getTime(),
      TreeValue: {},
      currentTab: null,
      TabDatas: {},
      SelectedValue: null,
      Posting: false
    }
  },
  computed: {
    MultActions() {
      if (this.config.MultActions) {
        return this.config.MultActions.map((act) => {
          return Object.assign({}, { Role: this.config.Role, RoleField: this.config.RoleField }, act)
        }).filter((act) => {
          return this.$matrix.CheckRoleByConfig(this.Context, act, act.Name || act.Type, 'add')
        })
      }
    },
    TypeActions() {
      if (this.config.TypeActions) {
        return this.config.TypeActions.map((act) => {
          return Object.assign({}, { Role: this.config.Role, RoleField: this.config.RoleField }, act)
        }).filter((act) => {
          return this.$matrix.CheckRoleByConfig(this.Context, act, act.Name || act.Type, 'add')
        })
      }
    },
    ConditionConfig() {
      let columns = this.$matrix.GetForm(this.Context, 'condition', this.config.Type, this.config, this.parent)
      columns.Columns = columns.Columns.filter((col) => {
        return col.Name !== this.config.TreeField && col.Title !== this.config.TreeField
      })

      return columns
    },
    DataConfig() {
      let list = this.$matrix.GetForm(this.Context, 'list', this.config.Type, this.config, this.parent)
      let res = {}
      list.Columns.forEach((col) => {
        if (['Array', 'Object', 'Link'].indexOf(col.Type) > -1) {
          res['Get' + col.Name] = true
        }
      })
      if (this.config.ParentField) {
        this.dataconfig.Params['Get' + this.config.ParentField] = true
      }
      this.dataconfig.Params = Object.assign(this.dataconfig.Params, res)
      this.dataconfig.Params.GetCount = true
      return this.dataconfig
    },
    TreeField() {
      if (this.config.TreeField) {
        let entity = this.$matrix.Models[this.config.Type]
        if (entity) {
          let res = Object.assign(
            { Height: this.config.TreeFieldHeight || '100%' },
            entity.Fields.find((t) => {
              return t.Name === this.config.TreeField || t.Title === this.config.TreeField
            }),
            { Items: this.config.Items, Active: this.Active }
          )
          return res
        }
      }
    }
  },
  methods: {
    OnDoMultActions(act, datas) {
      let alllist = datas.filter((d) => {
        return this.selected[d.Id] === true
      })

      let dolist = alllist.filter((d) => {
        let model = this.$matrix.Models[act.Type || act.Name]
        if (model.ParentState && !this.$matrix.Include(model.ParentState, d)) return false
        return true
      })
      let type = act.Type || act.Name
      act.Type = type
      if (type) {
        this.$matrix.AddDatas(
          this.Context,
          {},
          act,
          (res) => {
            this.handlePager(1)
          },
          dolist
        )
      }
    },
    GetMultDisabled(act, datas) {
      if (datas && datas.length > 0) {
        let alllist = datas.filter((d) => {
          return this.selected[d.Id] === true
        })

        let dolist = alllist.filter((d) => {
          let model = this.$matrix.Models[act.Type || act.Name]
          if (model.ParentState && !this.$matrix.Include(model.ParentState, d)) return false
          return true
        })

        return alllist.length !== dolist.length || alllist.length === 0
      }
      return true
    },
    OnDataChange(data) {
      let selected = {}
      if (this.MultActions && this.MultActions.length > 0) {
        data.Data.forEach((d) => {
          selected[d.Id] = false
        })
        this.$emit('event', { selected: selected })
      }
      if (this.config.Selected) {
        let SelectedValue = this.SelectedValue
        data.Data.forEach((d) => {
          selected[d.Id] = SelectedValue.indexOf(d.Id) > -1
        })
        let setSelectedValue = (val) => {
          this.SelectedValue = val
        }
        this.$emit('event', { selected: selected, setSelectedValue: setSelectedValue })
      }
    },
    OnSelectTab(e) {
      if (!e) {
        this.currentTab = null
      } else if (this.currentTab && this.currentTab.Title === e.Title) {
        this.currentTab = null
      } else {
        this.currentTab = e
      }
      this.handleSearch()
    },
    OnTreeChange(e) {
      //console.log(e)
      this.TreeValue = { [this.TreeField.Name]: e }
      this.handleSearch()
    },
    OnConditionChange(e) {
      //console.log(e)
      this.handleSearch()
    },
    handleReset() {
      this.Condition = {}
      this.Key = new Date().getTime()
      this.$nextTick(() => {
        this.handleSearch()
      })
    },
    GetDisabled(name) {
      if (name) {
        if (this.config.Roles && this.config.Roles[this.config.RoleField]) {
          return false === this.config.Roles[this.config.RoleField][this.config.Type + '_' + name]
        }
      }
      return false
    },
    handleSearch() {
      this.Condition = Object.assign(this.$refs.condition.GetValue(this.Condition), this.TreeValue)
      this.handlePager(1)
    },
    Reload() {
      this.handlePager(1)
    },
    handlePager(e) {
      this.$refs.loader.Load(e, Object.assign({}, this.Condition, this.currentTab ? this.currentTab.Params : {}), this.currentTab ? this.currentTab.RoleField : undefined)
      if (e === 1 || !e) {
        this.LadTabsData()
      }
    },
    handleLoadingChange(val) {
      if (val) {
        this.$refs.loader.LoadMore()
      }
    },
    OnAddsClick() {
      let entity = this.$matrix.Models[this.config.Type]
      let config = this.config.Adds || {}
      let field = entity.Fields.find((f) => {
        return f.Name === config.SelectField
      })
      config.Role = config.Role || this.config.RoleField || this.$matrix.Config.Role
      config.RoleField = config.RoleField || this.config.RoleField || this.$matrix.Config.Role
      if (field) {
        let allId = { Parent: this.parent, PageSize: 0, Fields: [field.Name] }
        this.$matrix.AjaxGet3(this.config.Type, 'GetList', allId, config.Role, config.RoleField).then((idData) => {
          let ids = idData.Items.map((t) => {
            return t[field.Name].Id
          })

          this.$matrix.SelectObject(field, config, ids).then((data) => {
            //console.log(this.config, this.parent)
            this.$matrix.CloseSelectionDialog()

            data = data.filter((d) => {
              return ids.indexOf(d) === -1
            })

            if (data.length > 0) {
              if (this.Posting) return
              this.Posting = true
              let updatas = data.map((d) => {
                let updateData = {}
                updateData[field.Name] = { Id: d }
                updateData.Parent = this.parent
                return this.$matrix.AjaxGet3(this.config.Type, 'Add', updateData, config.Role, config.RoleField)
              })
              Promise.all(updatas)
                .then((data) => {
                  this.Posting = false
                  this.handlePager(1)
                })
                .catch((e) => {
                  this.Posting = false
                  // this.$matrix.ShowError('写入有误')
                  this.handlePager(1)
                })
            }
          })
        })
      }
    },
    OnAddClick(e) {
      this.$matrix.AddData(
        this.Context,
        {},
        this.config,
        (data) => {
          this.$refs.loader.Load(1)
        },
        this.parent
      )
    },
    OnImportClick(e) {
      this.$matrix.ImportData(
        this.Context,
        this.config,
        (data) => {
          this.$refs.loader.Load(1)
        },
        this.parent
      )
    },
    OnExportClick(e) {
      this.Condition = this.$refs.condition.GetValue(this.Condition)
      let params = Object.assign({}, this.$refs.loader.GetParams(), this.Condition)

      this.$matrix.ExportData(this.Context, params, this.config)
    },
    OnTypeActionClick(act) {
      let type = act.Type
      if (type) {
        this.$matrix.AddData(
          this.Context,
          {},
          act,
          (data) => {
            if (act.Reset) {
              this.$matrix.Reset(this)
            } else {
              this.$refs.loader.Load(1)
            }
          },
          act.HasParent ? this.parent : null
        )
      } else if (act.View) {
        this.$emit('goview', act)
      } else {
        this.$matrix.ShowError('此功能正在开发中,请指定Type参数提交数据,或者指定View参数跳转到其他视图')
      }
    },
    LadTabsData() {
      if (this.config.Tabs) {
        let counts = this.config.Tabs.filter((f) => {
          return f.GetCount
        })
        let shs = counts.map((c) => {
          return this.$matrix.AjaxGet3(this.config.Type, 'Count', c.Params, this.config.Role, this.config.RoleField)
        })
        Promise.all(shs).then((datas) => {
          let res = {}
          datas.forEach((data, index) => {
            res[counts[index].Title] = data.Count
          })
          this.TabDatas = res
        })
      }
    }
  },
  created() {
    if (this.config.Selected) {
      console.log(this.query)
      this.SelectedValue = this.query.SelectedValue || []
    }
    this.LadTabsData()
  }
}
</script>
<style scoped>
.activeditem {
  padding: 8px;
  background-color: #2173dc;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.tabitem {
  padding: 8px;
  background-color: #f7f7f7;
  border-radius: 4px;
  cursor: pointer;
}
</style>
